import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';

import { UseFocus, useMountEffect } from '../../../hooks';
import { InputText } from '../../Forms/InputText';
import { SelectInput } from '../../Forms/selectInput';
import search from './../../../assets/images/h-search.svg';

type adminFormTypes = {
  classes: any;
  adminController: any;
  adminSubmit: any;
  filter: any;
  resetFilter: any;
  searchPage: any;
  setFilters: (src: any) => void;
  submitAdminFilter: any;
  adminUsersStore: any;
};

const AdminSearchForm: React.FC<adminFormTypes> = (props: adminFormTypes) => {
  const {
    classes,
    adminController,
    adminSubmit,
    filter,
    resetFilter,
    searchPage,
    setFilters,
    submitAdminFilter,
    adminUsersStore,
  } = props;

  const mapperRole = useCallback(
    (role: any) => ({
      label: role.name,
      optionClassName: classes.optionsClassName,
      value: role.name,
    }),
    [classes.optionsClassName],
  );

  const [input1Ref, setInput1Focus] = UseFocus();

  useMountEffect(setInput1Focus);

  const [roles, setRoles] = useState<any[]>([]);

  const fetchRoles = useCallback(async () => {
    if (adminUsersStore.AdminRolesList.length === 0) {
      await adminUsersStore.fetchAdminRoles();
    }
    setRoles(adminUsersStore.AdminRolesList.map(mapperRole));
  }, [adminUsersStore, mapperRole]);

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);

  return (
    <form onSubmit={adminSubmit(submitAdminFilter)} id={searchPage}>
      <FormControl error={false} fullWidth>
        <Typography
          component={'h3'}
          sx={{
            color: '#FFFFFF',
            fontFamily: 'FiraSans-Medium',
            fontSize: '15px',
            fontWeight: '500',
            height: '22px',
            letterSpacing: '1px',
            lineHeight: '22px',
            textTransform: 'capitalize',
            width: '166px',
          }}>
          Name
        </Typography>
        <Grid className={classes.borderBottom}>
          <Typography component={'div'} className={classes.searchBox}>
            <Grid item md={2} className={classes.dFlexJA}>
              <img className={classes.filterIcon} src={search} alt="search" />
            </Grid>
            <Grid item md={10}>
              <Controller
                control={adminController}
                defaultValue=""
                name="name"
                render={({
                  field: { onChange, value, name, ref },
                  formState,
                }) => {
                  return (
                    <InputText
                      inputRefObj={input1Ref}
                      name={name}
                      isRefreshValue={true}
                      // defaultValue={filter.name}
                      value={filter.name}
                      placeholder="Search"
                      onChangeText={(e: any) => {
                        onChange(e);
                        setFilters((pre: any) => ({
                          ...pre,
                          name: e,
                        }));
                      }}
                      isEditable={false}
                      className={classes.inputF}
                      type={'text'}
                      variant="outlined"
                    />
                  );
                }}
              />
            </Grid>
          </Typography>
        </Grid>
      </FormControl>
      <FormControl error={false} fullWidth>
        <Typography
          component={'h3'}
          sx={{
            color: '#FFFFFF',
            fontFamily: 'FiraSans-Medium',
            fontSize: '15px',
            fontWeight: '500',
            height: '22px',
            letterSpacing: '1px',
            lineHeight: '22px',
            textTransform: 'capitalize',
            width: '166px',
          }}>
          Role
        </Typography>
        <Grid className={classes.borderBottom}>
          <Typography component={'div'} className={classes.searchBox}>
            <Grid item md={2} className={classes.dFlexJA}>
              <img className={classes.filterIcon} src={search} alt="search" />
            </Grid>
            <Grid item md={10}>
              <Controller
                control={adminController}
                defaultValue=""
                name="role"
                render={({ field: { onChange, name, ref } }) => {
                  return (
                    <SelectInput
                      name={name}
                      isRefreshValue={true}
                      // defaultValue={filter.driverType}
                      value={filter.role}
                      inputRefObj={ref}
                      size={'small'}
                      onChangeText={(e: any) => {
                        onChange(e);
                        setFilters((pre: any) => ({
                          ...pre,
                          role: e,
                        }));
                      }}
                      isEditable={false}
                      selectClassName={classes.selectClassName}
                      placeHolder={'Select'}
                      optionsList={roles}
                    />
                  );
                }}
              />
            </Grid>
          </Typography>
        </Grid>
      </FormControl>
      <Grid container style={{ padding: '0px !important' }}>
        <Grid item md={6}>
          <Typography component={'div'} className={classes.resetF}>
            <Button
              variant="contained"
              className={' d-flex-ja '.concat(classes.resetF)}
              disabled={!filter.name && !filter.role}
              tabIndex={0}
              type="button"
              onClick={resetFilter}>
              RESET
            </Button>
          </Typography>
        </Grid>
        <Grid item md={6}>
          <Typography
            component={'button'}
            disabled={!filter.name && !filter.role}
            className={classes.filterBtn}
            style={{
              backgroundColor:
                !filter.name && !filter.role ? '#d3d3d3' : '#DEC330',
            }}
            type="submit">
            SEARCH
          </Typography>
        </Grid>
      </Grid>
    </form>
  );
};

export default observer(AdminSearchForm);
